module.exports = __webpack_public_path__ + "static/img/por_que_kllaar.e4827eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/empleador/home/por_que_kllaar.jpg
// module id = pb3P
// module chunks = 47